import { render, staticRenderFns } from "./backgroundVideoPlayer.vue?vue&type=template&id=0edc4c71&scoped=true&"
import script from "./backgroundVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./backgroundVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./backgroundVideoPlayer.vue?vue&type=style&index=0&id=0edc4c71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc4c71",
  null
  
)

export default component.exports